<template>
  <div>
    <v-row>
      <v-col cols="12" md="6" lg="4">
        <v-card class="elevation-12">
          <v-card-title>
            <v-btn color="primary" text :to="{name: 'moderator-statistics-region'}">{{ $t('moderatorStatisticsDashboard.cards.byRegion') }}</v-btn>
          </v-card-title>
        </v-card>
      </v-col>

      <v-col cols="12" md="6" lg="4">
        <v-card class="elevation-12">
          <v-card-title>
            <v-btn color="primary" text :to="{name: 'moderator-statistics-unit'}">{{ $t('moderatorStatisticsDashboard.cards.byDepartment') }}</v-btn>
          </v-card-title>
        </v-card>
      </v-col>

      <v-col cols="12" md="6" lg="4">
        <v-card class="elevation-12">
          <v-card-title>
            <v-btn color="primary" text :to="{name: 'moderator-statistics-organization'}">{{ $t('moderatorStatisticsDashboard.cards.byOrganization') }}</v-btn>
          </v-card-title>
        </v-card>
      </v-col>

      <v-col cols="12" md="6" lg="6">
        <v-card class="elevation-12">
          <v-card-title>
            <v-btn color="primary" text :to="{name: 'moderator-statistics-client'}">{{ $t('moderatorStatisticsDashboard.cards.byInternalClients') }}</v-btn>
          </v-card-title>
        </v-card>
      </v-col>

      <v-col cols="12" md="6" lg="6">
        <v-card class="elevation-12">
          <v-card-title>
            <v-btn color="primary" text :to="{name: 'moderator-client-unit-statistics'}">{{ $t('moderatorStatisticsDashboard.cards.byClientBranches') }}</v-btn>
          </v-card-title>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import {LAYOUT_TITLE_CHANGED} from "@/store/modules/layout/actions";

export default {
  name: "ModeratorStatisticsDashboardPage",
  created() {
    this.$store.dispatch(LAYOUT_TITLE_CHANGED, this.$t('moderatorStatisticsDashboard.pageTitle'))
  }
}
</script>

<style scoped>

</style>